import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useGrowthQuery } from '@/data/useGrowthQuery';
import { growthKeys } from '@/data/queryKeys';
import { useNotify } from '@/data/notifications';
import {
  diagnoseSeoIssue,
  dismissSeoIssue,
  exportSeoAuditPdf,
  fetchWebsiteHealth,
} from '../api';

export function useWebsiteHealth() {
  return useGrowthQuery({
    queryKey: growthKeys.websiteHealth(),
    queryFn: fetchWebsiteHealth,
  });
}

export function useWebsiteHealthMutations() {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: growthKeys.websiteHealth() });

  const diagnose = useMutation({
    mutationFn: diagnoseSeoIssue,
    onSuccess: () => {
      notify.success('Issue diagnosis queued');
      void invalidate();
    },
    onError: (e) => notify.error(e),
  });

  const dismiss = useMutation({
    mutationFn: dismissSeoIssue,
    onSuccess: () => {
      notify.success('Issue dismissed');
      void invalidate();
    },
    onError: (e) => notify.error(e),
  });

  const exportPdf = useMutation({
    mutationFn: exportSeoAuditPdf,
    onSuccess: () => notify.success('SEO audit export started'),
    onError: (e) => notify.error(e),
  });

  return { diagnose, dismiss, exportPdf };
}
